import { ChartSettings, ChartStyle, ChartFeatures } from "./types";

// Default dark chart template (the shipped Custom scheme): cyan/blue up,
// red down on a near-black grid — matches the terminal's dark UI.
export const DEFAULT_CHART_STYLE: ChartStyle = {
  scheme: "custom",
  foreground: "#D1D5DB",   // Light gray text
  grid: "#000000",         // Near-black grid on dark background
  barUp: "#06B6D4",        // Cyan bars for up
  barDown: "#F56565",      // Salmon-red bars for down
  bullCandle: "#3B82F6",   // Blue candle for up
  bearCandle: "#EF4444",   // Red candle for down
  lineChart: "#6366F1",    // Indigo line
  volumes: "#10B981",      // Green volumes
  bidPriceLine: "#3B82F6", // Blue
  askPriceLine: "#EF4444", // Red
  stopsLevels: "#F59E0B",  // Amber
};

export const DEFAULT_CHART_FEATURES: ChartFeatures = {
  volumes: false,
  tickVolumes: false,
  askPriceLine: true,
  periodSeparators: false,
  countdownToBarClose: false,
  tradeOrders: true,
  tradePositions: true,
  slTpLevels: true,
  tradeHistory: false,
  preloadChartsData: true,
  ohlc: true,
  isPipsVisible: false,
  autoSlTpModify: false,
};

// v2: default scheme unified to blue/red on black grid, volumes pane off by default.
export const CHART_SETTINGS_VERSION = 2;

export const DEFAULT_CHART_SETTINGS: ChartSettings = {
  selectedSymbol: "EURUSD",
  selectedTimeFrame: "M1",
  chartType: "candlesticks",
  availableTimeframes: ["M1", "M5", "M15", "M30", "H1", "H4", "D1", "W1", "MN"],
  chartStyle: DEFAULT_CHART_STYLE,
  features: DEFAULT_CHART_FEATURES,
  settingsVersion: CHART_SETTINGS_VERSION,
} as const;
